import { IconBaseType } from "@/v2-components/core/icon/type";
import { cn } from "@/libs/utils";

export default function ChevronUpIcon({ className }: IconBaseType) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("w-6 h-6", className)}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9348 9.05606L6 13.9484L7.06523 15.0045L12 10.1121L16.9348 15.0045L18 13.9484L13.0652 9.05606L12 7.99999L10.9348 9.05606Z"
        fill="currentColor"
      />
    </svg>
  );
}
